var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.00154C14.2239 2.00051 14.1978 2 14.1716 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V7.82843C20 7.80223 19.9995 7.77608 19.9985 7.75H17C15.4812 7.75 14.25 6.51878 14.25 5V2.00154ZM7.25 7C7.25 6.58579 7.58579 6.25 8 6.25H12C12.4142 6.25 12.75 6.58579 12.75 7C12.75 7.41421 12.4142 7.75 12 7.75H8C7.58579 7.75 7.25 7.41421 7.25 7ZM12.5 17C11.1193 17 10 15.8807 10 14.5C10 13.1193 11.1193 12 12.5 12C13.8807 12 15 13.1193 15 14.5C15 15.8807 13.8807 17 12.5 17ZM11 18.2095C11.4632 18.397 11.9696 18.5002 12.5 18.5002C13.0304 18.5002 13.5368 18.397 14 18.2095V20.066C14 20.4653 13.5549 20.7035 13.2227 20.482L12.7774 20.1851C12.6094 20.0732 12.3906 20.0732 12.2226 20.1851L11.7773 20.482C11.4451 20.7035 11 20.4653 11 20.066V18.2095ZM8 9.25H16C16.4142 9.25 16.75 9.58579 16.75 10C16.75 10.4142 16.4142 10.75 16 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10C7.25 9.58579 7.58579 9.25 8 9.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 6.25L15.75 2.75V5C15.75 5.69036 16.3096 6.25 17 6.25H19.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateAlt);
export default __webpack_public_path__ + "static/media/certificate-alt.f1f2ee16dcd0d90d765337dc6b977678.svg";
export { ForwardRef as ReactComponent };